import { connect } from 'react-redux';
import { rateStay } from 'store/stayRating/actions';
import StayRating from './StayRating';

const mapDispatchToProps = (dispatch) => ({
  onRated: ({ booking, rating }) => {
    dispatch(rateStay({ booking, rating }));
  },
});

const ConnectStayRating = connect(null, mapDispatchToProps)(StayRating);

export default ConnectStayRating;
